import { render, staticRenderFns } from "./province-search.vue?vue&type=template&id=6fb351fd"
import script from "./province-search.vue?vue&type=script&lang=js"
export * from "./province-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports